import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Box } from '@twilio-paste/core/box';
import CompositeCallout from '@twiliointernal/services-common/components/compositeCallout';
import { compositeCalloutTypes } from '@twiliointernal/services-common/components/compositeCallout';

import { useSegment } from '@twiliointernal/e2-commons-shared-hooks';
import { logger } from '@twiliointernal/e2-commons-shared-libs';

import { trackingDetails } from '../../definitions/constants';
import { constants, copy } from './definitions';
import { useUserDetails } from '../../hooks';
import { selectSearchValue } from '../../stores/searchValue.slice';

import styles from './contactSupportCallout.module.css';

const ContactSupportCallout = (): ReactElement => {
  const { account, user, isLoading, isLoggedIn } = useUserDetails();
  const { trackEvent } = useSegment({
    accountSid: account?.sid,
    userSid: user?.sid,
    isLoggedIn,
    isLoading,
  });

  const searchValue = useSelector(selectSearchValue);

  const navigate = useNavigate();

  const trackingData = {
    searchValue,
  };

  const allUsersCtaButtonOptions: compositeCalloutTypes.CtaButtonOptions[] = [
    {
      variant: 'primary',
      children: copy.compositeCallout.chatWithHCAButton,
      onClick: () => navigate('/'),
      onTrack: (): void => {
        const eventName = trackingDetails.allUsersChatWithHCAButton;
        logger.info(`${constants.LOG_PREFIX}::[${eventName}]`);
        trackEvent(eventName, trackingData);
      },
    },
  ];

  return (
    <Box as="div" className={styles.contactSupportCalloutContainer}>
      <CompositeCallout
        heading={copy.compositeCallout.heading}
        variant="neutral"
        ctaButtonOptions={allUsersCtaButtonOptions}
      />
    </Box>
  );
};

export default ContactSupportCallout;
